export default __webpack_public_path__ + "static/media/116-BF-300V2.3eb268c9.png";